import "./App.css";
import { Yajilin } from "./components/Yajilin";
import { Gojuon } from "./components/Gojuon";
import { BrowserRouter, Route, Routes } from "react-router-dom";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/gojuon" element={<Gojuon />} />
        <Route path="/gojuon/:target" element={<GojuonWithParams />} />
        <Route path="/50on-days" element={<Gojuon />} />
        <Route path="/50on-days/:target" element={<GojuonWithParams50onDays />} />
        <Route path="/*" element={<Yajilin />} />
      </Routes>
    </BrowserRouter>
  );
}

// URL パラメータから target を取得するラッパー
function GojuonWithParams() {
  const target = window.location.pathname.split("/gojuon/")[1] || "";
  return <Gojuon initialTarget={decodeURIComponent(target)} />;
}

function GojuonWithParams50onDays() {
  const target = window.location.pathname.split("/50on-days/")[1] || "";
  return <Gojuon initialTarget={decodeURIComponent(target)} />;
}

export default App;
